import { provideChameleonDesignSystem } from '../../provideChameleonDesignSystem';
import { chameleonDataTableBodyV2 } from './DataTableBodyV2.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonDataTableBodyV2({ prefix }));
}
